export type Dimensionality = { w: number; h: number };
export const DIMENSIONALITY = "Dimensionality";
